import client from "socket.io-client";
import { SOCKET_URL } from "../../static/env";

const socket = client(SOCKET_URL, {
  transports: ["websocket"],
  reconnectionAttempts: 15,
});

function registerWebClient() {
  try {
    const userId = localStorage.getItem("user_id");
    if (!userId) {
      console.warn("[socket] register skip: no user_id in localStorage");
      return;
    }
    const payload = { user_id: userId, is_buh: false };
    console.log("[socket] emit register", payload);
    socket.emit("register", payload);
  } catch (err) {
    console.warn("[socket] register error", err);
  }
}

socket.on("connect", () => {
  console.log("[socket] connected", { id: socket.id, url: SOCKET_URL });
  registerWebClient();
});

socket.on("disconnect", (reason) => {
  console.warn("[socket] disconnect", reason);
});

socket.on("connect_error", (err) => {
  console.error("[socket] connect_error", err?.message || err, { url: SOCKET_URL });
});

socket.io.on("reconnect", (attempt) => {
  console.log("[socket] reconnect attempt", attempt);
  registerWebClient();
});

export function useSocket() {
  return { socket };
}

export { socket };
